export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[960px] flex-col gap-xl px-xl py-lg',
	pageEyebrow: 'mb-2xs text-[11px] font-medium uppercase tracking-wider text-purple-700',
	pageH1: 'text-[22px] font-semibold leading-tight tracking-tight text-default',
	pickerCard:
		'flex flex-1 cursor-pointer flex-col gap-2xs rounded-md border border-subtle bg-white px-md py-md text-left transition-colors hover:border-purple-500 hover:bg-purple-50',
};
